import classNames from 'classnames'
import { n_book_lessons, n_common, s_schedule, s_schedule_enter } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
const CouponCard = ({
  selected = false,
  id,
  duration,
  title,
  exp_dates,
  count,
  handleCouponClick = null,
  type = null,
  isPaidForRookieLesson = false,
  isRookieLesson = false,
  isWeeklyLessonPackage = false,
  isAvailable = true,
  isFree = false,
}) => {
  const { t } = useTranslation()

  return (
    <div
      className={classNames('mb-[8px] flex cursor-pointer rounded-[5px] py-[12px] pl-[12px] pr-[24px] shadow-sm', {
        'border-[1.5px] border-purple-500 bg-purple-50': selected,
        'border-1 border-gray-100': !selected,
        'bg-gray-100': !isAvailable,
      })}
      onClick={(e) =>
        handleCouponClick && isAvailable
          ? handleCouponClick(e, type, {
              id,
              title,
              exp_dates,
              count,
              duration,
              isPaidForRookieLesson,
              isWeeklyLessonPackage,
            })
          : null
      }
    >
      <div>
        <div className="Body2-14Bd flex h-full items-center justify-center text-gray-500">
          {duration}
          {t(s_schedule_enter.min)}
        </div>
      </div>
      <div className="ml-[16px]">
        <div className="flex flex-col items-start">
          <div className="flex flex-row gap-x-[4px]">
            {isFree && <div className="Body2-14Bd text-blue-500">{t(n_book_lessons.select_credit.label_free)}</div>}
            {isWeeklyLessonPackage && <div className="Body2-14Bd text-red-600">{t(n_common.label_weekly)}</div>}
          </div>
          <p className="Body1-16Bd">{title}</p>
        </div>
        <div className="Body2-14Md text-gray-500">{t(s_schedule.valid_n_days(exp_dates))}</div>
      </div>
      <div className="ml-auto flex items-center">
        <div className="text-right">
          <div className="Body2-14Md text-gray-500">{t(s_schedule_enter.available)}</div>
          <div className="Body1-16Bd text-gray-800">{count}</div>
        </div>
      </div>
    </div>
  )
}

export default CouponCard
